/* eslint-disable max-len */
// External deps
import { useState, useContext } from 'react';
import { ModalGeneric } from 'ypf-pas-general-ui-components';
import { useFormikContext } from 'formik';
import { PropTypes } from 'prop-types';
// import { BsFillExclamationCircleFill } from 'react-icons/bs';

// Internal deps
import LoaderContext from '../../../../context/LoaderProvider';
import { ubicationTypeEnum } from '../../../../utils/dataStatus';
import { checkRol } from '../../../../security';
import { notificador, proveedorNotificador } from '../../../../security/constantsRols';
import AddUbicationForm from '../../../../components/AddUbicationForm/AddUbicationForm';
import useUbicationForm from '../../../../components/CreateServiceRequest/UbicationForm/useUbicationForm';
import { getAllBusinessUnits, getBusinessUnits } from '../../../../services/yclickMaster';
import AccountAssignmentObject from '../../../../components/AccountAssignmentObject/AccountAssignmentObject';
import useRequestDetailPermissions from '../../../../hooks/useRequestDetailPermissions';
import { getUbicationLabel } from '../../../../utils/getUbicationLabel';

const AutomaticUbication = ({ createSDS }) => {
  const { values, setFieldValue, setFieldTouched, errors, touched } = useFormikContext();

  const {
    ubicationTypeSelect,
    optionUnits,
    event: events,
    equipment,
    aditionalTeams,
    cantWells,
    handleSwitchAdditionTeams,
    setOptionUnits,
    setUunnState,
    setUbicationState,
    setTeamState,
    setEventState,
    fetchDataUbication,
    getEventIdPozo,
    getEventsIdTeam,
    getUnitsBusinessId,
    getOperationByInstallationId,
    getUnitsBusinessOfUser,
    fetchDataInstallation,
    typeOfEventOptions,
    getTypeOfEventsOptions,
    resetField
  } = useUbicationForm(
    false,
    true,
    null,
    null,
    true,
    createSDS,
    values?.ubicationType?.id === ubicationTypeEnum.locacion
  );

  const ubicationLabel = getUbicationLabel(values?.ubication?.ubicationType?.id);

  const [showModal, setShowModal] = useState(false);

  const { setLoader } = useContext(LoaderContext);

  const {
    permissions: { typeAndObjectImputation }
    // mockeamos los valores que recibe useRequestDetailPermissions
    // porque este custom hook se usa en la pagina de detalle de una solicitud
  } = useRequestDetailPermissions({ notifyTo: 3, isASDS: true, isOyM: false });

  const getBusinessUnit = async () => {
    try {
      setLoader(true);
      let data;

      if (checkRol(notificador)) {
        data = await getBusinessUnits();
      }
      if (checkRol(proveedorNotificador)) {
        data = await getAllBusinessUnits();
      }
      setOptionUnits(data);
      if (data.length === 1) {
        setUunnState(data[0]);
      }
      setLoader(false);
    } catch (error) {
      setOptionUnits([]);

      setLoader(false);
    }
  };
  // Rollback ASDS: Filtro las opciones desde maestros para solo mostrar servicios de torre
  const ubicationTypeOptions = ubicationTypeSelect.filter(
    (ubication) =>
      ubication.id === ubicationTypeEnum.pozo || ubication.id === ubicationTypeEnum.locacion
  );

  const objectUbicationType = {
    label: 'Tipo de ubicación',
    placeholder: 'Buscar por tipo de ubicación',
    options: ubicationTypeOptions,
    name: 'ubication.ubicationType',
    onChange: (val) => {
      if (val?.id !== values?.ubication?.ubicationType?.id) {
        setFieldValue('ubication.ubicationType', val);
        if (values?.ubication?.uunn) {
          setFieldTouched('ubication.uunn');
        }
        setFieldValue('ubication.uunn', null);
        if (values?.ubication?.ubication) {
          setFieldTouched('ubication.ubication');
        }
        setFieldValue('ubication.ubication', '');
        if (values?.ubication?.event) {
          setFieldTouched('ubication.event');
        }
        setFieldValue('ubication.event', null);
        if (values?.ubication?.team) {
          setFieldTouched('ubication.team');
        }
        setFieldValue('ubication.installation', null);
        setFieldValue('ubication.team', null);
        getBusinessUnit();
        setFieldValue('imputationObject', {
          wells: [],
          wellsCopy: []
        });
      }
    },
    value: values?.ubication.ubicationType
  };

  const objectUunn = {
    options: optionUnits,
    onChange: (val) => {
      if (val?.id !== values?.ubication?.uunn?.id) {
        setFieldValue('ubication.uunn', val);
        if (values?.ubication?.event) {
          setFieldTouched('ubication.event');
        }
        setFieldValue('ubication.event', null);
        if (values?.ubication?.team) {
          setFieldTouched('ubication.team');
        }
        setFieldValue('ubication.team', null);
        if (values.provider?.contract) {
          setFieldTouched(`provider.contract`);
        }
        setFieldValue(`provider.contract`, null);
        if (values.provider?.notificate) {
          setFieldTouched(`provider.notificate`);
        }
        setFieldValue(`provider.notificate`, null);
        setUunnState(val);
      }
    },
    label: 'Unidad de Negocio',
    placeholder: 'Buscar por unidad de Negocio',
    isDisabled: !values.ubication.ubicationType,
    errors: errors.ubication?.uunn,
    value: values.ubication.uunn,
    name: 'ubication.uunn'
  };

  const objectUbication = {
    placeholder: 'Buscar por nombre',
    name: 'ubication.ubication',
    onChange: (val) => {
      if (val?.id !== values?.ubication?.ubication?.id) {
        setFieldValue('ubication.ubication', val);
        if (values?.ubication?.event) {
          setFieldTouched('ubication.event');
        }
        setFieldValue('ubication.event', null);
        if (values?.ubication?.team) {
          setFieldTouched('ubication.team');
        }
        setFieldValue('ubication.team', null);
        if (val?.id) {
          getUnitsBusinessId(val?.id);
          setUbicationState(val);
        } else {
          setFieldValue('ubication.uunn', null);
          setUunnState(null);
          getUnitsBusinessOfUser();
        }
        resetField(values?.ubication?.typeEvent, 'ubication.typeEvent', null);
        setFieldValue('imputationObject', {
          wells: [],
          wellsCopy: []
        });
        // Solo si es pozo se llama al servicio de eventos
        if (values.ubication?.ubicationType?.id === ubicationTypeEnum.pozo && val) {
          getEventIdPozo(val);
        }
        if (val && values.ubication?.ubicationType?.id === ubicationTypeEnum.locacion) {
          getTypeOfEventsOptions(val?.id);
        }
      }
      if (!val) {
        setFieldValue('service.service', null);
        setFieldValue('ubication.team', null);
        setFieldValue('ubication.event', null);
        resetField(values?.ubication?.typeEvent, 'ubication.typeEvent', null);
      }
    },
    value: values.ubication.ubication,
    isDisabled: !values.ubication.ubicationType,
    label: ubicationLabel,
    fetchData: (val) =>
      fetchDataUbication(val, values.ubication.uunn ? values.ubication.uunn.id : 0)
  };

  const objectEvent = {
    label: 'Evento',
    placeholder: 'Selecciona un evento',
    options: events,
    name: 'ubication.event',
    isDisabled: !values.ubication.ubicationType || !values.ubication.ubication,
    onChange: async (val) => {
      if (val?.eventoPozoId !== values?.ubication?.event?.eventoPozoId) {
        setFieldValue('ubication.event', val);
        if (values?.ubication?.team) {
          setFieldTouched('ubication.team');
        }
        setFieldValue('ubication.team', null);
        if (values?.service?.service) {
          setFieldTouched('service.service');
        }
        setFieldValue('service.service', null);
        // TODO: Agregar wells por defecto en vez de mock
        setFieldValue('imputationObject.wells', []);
        if (values?.provider?.contract) {
          setFieldTouched(`provider.contract`);
        }
        setFieldValue(`provider.contract`, null);
        if (values?.provider?.notificate) {
          setFieldTouched(`provider.notificate`);
        }
        setFieldValue(`provider.notificate`, null);
        getEventsIdTeam(val);
        setEventState(val);
      }
    },
    value: values.ubication.event
  };

  const objectTeam = {
    label: 'Equipo',
    placeholder: 'Selecciona un equipo',
    options: equipment,
    name: 'ubication.team',
    isDisabled: !values.ubication.ubicationType || !values.ubication.event,
    onChange: async (val) => {
      if (val?.id !== values?.ubication?.team?.id) {
        setFieldValue('ubication.team', val);
        setTeamState(val);
      }
    },
    value: values.ubication.team
  };

  const objectInstallation = {
    label: 'Instalación',
    name: 'ubication.installation',
    onChange: (value) => {
      if (value !== values.ubication.installation?.id) {
        setFieldValue('ubication.installation', value);
        setFieldTouched('ubication.installation');
        if (value) {
          getOperationByInstallationId(value.id);
        } else {
          setFieldValue('ubication.uunn', null);
          setFieldValue('ubication.ubication', null);
          getUnitsBusinessOfUser();
        }
      }
    },
    placeholder: 'Seleccione una instalación',
    value: values.ubication.installation,
    fetchData: (value) => fetchDataInstallation(value)
  };

  const objectTypeEvent = {
    label: 'Tipo de Evento',
    placeholder: 'Selecciona tipo de evento',
    options: typeOfEventOptions,
    name: 'ubication.typeEvent',
    isDisabled: !values.ubication?.ubication,
    onChange: (val) => {
      if (val?.id !== values?.ubication?.typeEvent?.id) {
        setFieldValue('ubication.typeEvent', val);
        setFieldTouched('ubication.typeEvent');
      }
    },
    isInvalid:
      errors?.ubication?.typeEvent && touched?.ubication?.typeEvent
        ? !!touched?.ubication?.typeEvent && !!errors?.ubication?.typeEvent
        : false,

    value: values.ubication?.typeEvent,
    errors: errors?.ubication?.typeEvent
  };

  return (
    <>
      <AddUbicationForm
        aditionalTeams={aditionalTeams}
        handleSwitchAdditionTeams={handleSwitchAdditionTeams}
        isCreateASDS
        objectEvent={objectEvent}
        objectInstallation={objectInstallation}
        objectTeam={objectTeam}
        objectTypeEvent={objectTypeEvent}
        objectUbication={objectUbication}
        objectUbicationType={objectUbicationType}
        objectUunn={objectUunn}
        onClickTypeInputation={() => setShowModal(true)}
      />

      <ModalGeneric
        backdrop="static"
        infoModal
        onHide={() => !values.imputationObject?.wells?.some((w) => w?.add) && setShowModal(false)}
        primaryAction={() => {
          setShowModal(false);
        }}
        primaryActionDisabled={
          errors?.imputationObject?.wells?.length > 0 ||
          values.imputationObject?.wells?.some((w) => w.add)
        }
        primaryActionLabel="Aceptar"
        secondaryAction={() => setShowModal(false)}
        secondaryActionDisabled={values.imputationObject?.wells?.some((w) => w?.add)}
        secondaryActionLabel="Salir"
        show={showModal}
        size="xl"
        title="Detalles del tipo y objeto de imputación"
      >
        {showModal && (
          <AccountAssignmentObject
            createSDS
            disabledImputationForm={!typeAndObjectImputation.editObjectImputation}
            eventId={values.ubication.event?.id}
            imputationObjectDefault={!typeAndObjectImputation.editObjectImputation}
            locationId={values.ubication.ubication?.id}
            logicDeleted={false}
            maxCantWells={cantWells || 0}
            showDetailWell
            typeOfEventId={values?.ubication?.typeEvent?.id}
            ubicationType={values.ubication.ubicationType}
          />
        )}
      </ModalGeneric>
    </>
  );
};

export default AutomaticUbication;

AutomaticUbication.propTypes = {
  createSDS: PropTypes.bool
};

AutomaticUbication.defaultProps = {
  createSDS: false
};
